import { createContext, useState, useContext, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import toimitusClass from "src/data/toimitus/toimitusClass";
import { useUserData } from "./userContext";

export const ToimitusContext = createContext();

export const ToimitusProvider = ({ children, keikkaId }) => {
  const { token, socket } = useUserData();
  const [toimitus, setToimitus] = useState();
  const [, setToimitusHash] = useState("");
  const [toimitusLoadingStatus, setToimitusLoadingStatus] = useState({
    isLoaded: false,
    error: null,
    state: "initial",
  });

  useEffect(() => {
    if (!keikkaId || !token || !socket) return;

    const _asynk = async () => {
      setToimitusLoadingStatus({ isLoaded: false, error: null, state: "loading toimituslist" });
      await loadToimitus();
    };
    _asynk();
  }, [keikkaId, token, socket]);

  const loadToimitus = async () => {
    setIsLoaded({ ...isLoaded, init: false });
    const toimitus = new toimitusClass(keikkaId);
    const r = await toimitus.init(token, socket);
    if (r === true) {
      doSetToimitus(toimitus);
      setToimitusLoadingStatus({ isLoaded: true, error: null, state: "success" });
    } else {
      doSetToimitus(null);
      setToimitusLoadingStatus({
        isLoaded: true,
        error: "error initializing toimitus",
        state: "error",
      });
    }
    setIsLoaded({ ...isLoaded, init: true });
  };
  const reloadToimitus = async () => {
    await loadToimitus();
  };

  const doSetToimitus = useCallback(
    (toimitus) => {
      setToimitus(toimitus);
      setToimitusHash(toimitus?.hash);
    },
    [toimitus, toimitus?.hash]
  );

  const resetLoadingState = () => {
    setIsLoaded({ ...isLoaded, init: false });
  };
  const [isLoaded, setIsLoaded] = useState({
    init: false,
  });
  const isLoadedPercent = {
    percent: Math.round(
      (Object.values(isLoaded).filter((v) => v).length / Object.keys(isLoaded).length) * 100
    ),
    count: Object.keys(isLoaded).length,
  };

  const setKuorma = (kuorma) => {
    if (!toimitus) return;
    const _kuorma = toimitus.betoniKuormat.find(
      (k) => k.toimitusBetoniId === kuorma.toimitusBetoniId
    );
    console.log(_kuorma);
    // replace kuorma in toimitus.betoniKuormat
    if (_kuorma) {
      const index = toimitus.betoniKuormat.indexOf(_kuorma);
      if (index > -1) {
        toimitus.betoniKuormat[index] = kuorma;
      }
    } else {
      // add new kuorma to betoniKuormat
      toimitus.betoniKuormat.push(kuorma);
    }
    console.log(toimitus);
  };

  return (
    <ToimitusContext.Provider
      value={{
        toimitus,
        doSetToimitus,
        setToimitus: doSetToimitus,
        toimitusStatus: toimitusLoadingStatus,
        reloadToimitus,
        reload: reloadToimitus,
        isLoadedPercent,
        resetLoadingState,
        setKuorma,
      }}>
      {children}
    </ToimitusContext.Provider>
  );
};

export const useToimitusData = () => useContext(ToimitusContext);

ToimitusProvider.propTypes = {
  children: PropTypes.node.isRequired,
  keikkaId: PropTypes.number,
};
